// Keeps both controls in sync with the motion choice.
(function () {
  'use strict';

  if (window.__h12pause) {
    return;
  }
  window.__h12pause = true;

  var start = function () {
    var hero = document.querySelector('.hero12');
    var buttons, media, stored, chosen, paused, i;

    if (!hero) {
      return;
    }
    buttons = hero.querySelectorAll('[data-h12-pause]');
    if (!buttons.length) {
      return;
    }

    media = window.matchMedia('(prefers-reduced-motion: reduce)');
    try {
      stored = window.sessionStorage.getItem('loa-h12-motion');
    } catch (e) {}
    chosen = stored === 'paused' || stored === 'play';
    paused = chosen ? stored === 'paused' : media.matches;

    var apply = function () {
      var j;
      hero.removeAttribute(paused ? 'data-h12-go' : 'data-h12-paused');
      hero.setAttribute(paused ? 'data-h12-paused' : 'data-h12-go', '');
      for (j = 0; j < buttons.length; j += 1) {
        buttons[j].setAttribute('aria-pressed', paused ? 'true' : 'false');
        buttons[j].setAttribute('aria-label', buttons[j].getAttribute(
          paused ? 'data-label-play' : 'data-label-pause'
        ));
      }
    };

    var press = function () {
      chosen = true;
      paused = !paused;
      apply();
      try {
        window.sessionStorage.setItem('loa-h12-motion', paused ? 'paused' : 'play');
      } catch (e) {}
    };

    var change = function (event) {
      if (!chosen) {
        paused = event.matches;
        apply();
      }
    };

    apply();
    for (i = 0; i < buttons.length; i += 1) {
      buttons[i].addEventListener('click', press);
    }
    if (media.addEventListener) {
      media.addEventListener('change', change);
    } else {
      media.addListener(change);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
